<template>
	<v-flex xs12>
		<v-container fluid grid-list-md v-if="!isFetching"> 	
    		<v-text-field
    		:value="video"
    		:label="translater.__('Youtube Video Link')"
    		@keyup="setVideoFilePath($event)"
    		></v-text-field>
    		<v-card-actions>
			        	<!--v-btn :disabled="!valid" @click="update()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="update"></SuccessButton>
			        	<!--v-btn @click="edit = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => edit = false"></ErrorButton>
			        </v-card-actions>
    	</v-container>
	</v-flex>
</template>

<script>

	import SuccessButton from '../../../common/components/SuccessButton'
	import ErrorButton from '../../../common/components/ErrorButton'

	export default {
		name: 'EditYoutubeVideoTask',
		components: {
			SuccessButton, ErrorButton
		},

		mounted()
		{
			this.$nextTick(() => {

				let path = undefined
				let editableTask = this.$store.getters['checkpoints/editableTask']
				
				path = editableTask.question.files[0].path;
				if(!path.includes('youtu.be') && !path.includes('youtube.com'))
				{
					path = 'https://www.youtube.com/watch?v=' + path;
				}

				this.video = path;
			})
		},

		methods: {
			update()
			{
				this.$store.dispatch('checkpoints/updateTask');
			},

			setVideoFilePath(e)
			{
				let path = e.target.value;
				this.video = path;

			}
		},
		computed: {

				edit:{
				get()
				{
					return this.$store.getters['checkpoints/editTask'];
				},
				set(value)
				{
					this.$store.dispatch('checkpoints/setEditTask', value)
				}

			},
			
			
			video:
			{
				get()
				{
					
					return this.$store.getters['checkpoints/editableTask'].question.files[0].path;
					
				
				},

				set(value)
				{
					//console.log(value)
					this.$store.commit('checkpoints/setEditableTaskFilePath', value)
					this.$store.dispatch('checkpointsValidator/validateYoutubeVideoTask', value)
					.then((validation) => {
						this.$store.commit('checkpointsValidator/setValidEdit', validation.valid)
					})
					
					
					


				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			valid: {
				get()
				{
					return this.$store.getters['checkpointsValidator/isValidEdit'];
				}
			},

			isFetching: {
				get()
				{
					return this.$store.getters['checkpoints/isFetching']
				}
			}
		}
	}
</script>